import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import authService from '../services/authService';
import { trackEvent } from '../utils/analytics';
import { ErrorMessage } from './common';
import './Auth.css';

function RegistrationSuccess() {
  const { t } = useTranslation();
  const location = useLocation();
  const email = location.state?.email || sessionStorage.getItem('registration_email') || '';
  const [resendStatus, setResendStatus] = useState('idle');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleResend = async () => {
    if (!email) {
      trackEvent('verify_email_resend_failed', { reason: 'email_not_provided' });
      setError(t('auth.registrationSuccess.emailNotProvided'));
      return;
    }

    trackEvent('verify_email_resend_submit');
    setResendStatus('loading');
    setError('');

    try {
      const response = await authService.resendVerification(email);
      trackEvent('verify_email_resend_success');
      setResendStatus('success');
      setMessage(response.message);
    } catch (err) {
      trackEvent('verify_email_resend_failed', { reason: 'server_error' });
      setResendStatus('error');
      setError(err.response?.data?.message || t('auth.registrationSuccess.resendFailed'));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="success-icon">&#9993;</div>
        <h2>{t('auth.registrationSuccess.title')}</h2>

        <div className="success-message">
          <p>
            {t('auth.registrationSuccess.description')}
          </p>
          <p className="email-highlight">{email || t('auth.registrationSuccess.yourEmail')}</p>
          <p className="hint">
            {t('auth.registrationSuccess.hint')}
          </p>
        </div>

        <ErrorMessage message={error} />

        {resendStatus === 'success' && (
          <div className="success-alert">
            {message}
          </div>
        )}

        <div className="resend-section">
          <p>{t('auth.registrationSuccess.notReceived')}</p>
          <button
            className="btn btn-secondary"
            onClick={handleResend}
            disabled={resendStatus === 'loading'}
          >
            {resendStatus === 'loading' ? t('auth.registrationSuccess.resending') : t('auth.registrationSuccess.resend')}
          </button>
        </div>

        <div className="auth-links">
          <Link to="/login" className="link-button">
            {t('auth.registrationSuccess.toLogin')}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RegistrationSuccess;
